import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider, ToastProvider } from "@payflow/ui";
import { AuthProvider } from "./contexts/AuthContext";
import { TenantThemeProvider } from "./contexts/TenantThemeContext";
import App from "./App";
import "./i18n";
import "./index.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider defaultTheme="system">
        <ToastProvider>
          <AuthProvider>
            <TenantThemeProvider>
              <App />
            </TenantThemeProvider>
          </AuthProvider>
        </ToastProvider>
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
);
